export const debugLog = console.debug;

export const errorLog = console.error;
